/**
 * Strips diacritical marks from a name string so it can be safely
 * submitted to booking suppliers that only accept ASCII characters.
 * e.g. "Jürgen" → "Jurgen", "Stütz" → "Stutz"
 */
export function sanitizeName(name: string): string {
  return name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
